// extracted by mini-css-extract-plugin
export default {"navtabContainer":"employee_navtabContainer__i8vMR"};